import { awsUrl, awsUrlcommon, apiUrlReliance, apiUrlRelianceElasticSearch } from "./config";
import { authHelper, clearAuthData } from "./utilis/authHelper";
import axios from "axios";

var CryptoJS = require("crypto-js");
let authToken = localStorage.getItem('authToken') || '';
let refreshToken = localStorage.getItem('refreshToken') || '';
let isRefreshing = false;
let refreshPromise = null;
const apiUrl = awsUrl();
const apiUrlcommon = awsUrlcommon();
const apiUrlRelianceConst = apiUrlReliance();
const apiUrlRelianceElasticSearchConst = apiUrlRelianceElasticSearch();
const ENC_KEY = decodeURIComponent(
  process.env.REACT_APP_ENCRYPTION_KEY || ""
);

// Secure storage wrapper
const isProduction = process.env.NODE_ENV === 'production';
export const secureStorage = {
  setItem: (key, value) => {
    try {
      if (isProduction) {
        const encryptedValue = CryptoJS.AES.encrypt(value, ENC_KEY).toString();
        localStorage.setItem(key, encryptedValue);
      } else {
        localStorage.setItem(key, value);
      }
    } catch (error) {
      console.error('Secure storage set error:', error);
    }
  },
  
  getItem: (key) => {
    try {
      const value = localStorage.getItem(key);
      if (!value) return null;
      
      if (isProduction) {
        const bytes = CryptoJS.AES.decrypt(value, ENC_KEY);
        return bytes.toString(CryptoJS.enc.Utf8);
      }
      return value;
    } catch (error) {
      console.error('Secure storage get error:', error);
      return null;
    }
  },
  
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Secure storage remove error:', error);
    }
  }
};

// Initialize auth tokens using secure storage
authToken = secureStorage.getItem('authToken') || '';
refreshToken = secureStorage.getItem('refreshToken') || '';

export function Captcha() {
  var alpha = new Array(
    "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M",
    "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
    "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m",
    "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"
  );
  var i;
  for (i = 0; i < 6; i++) {
    var a = alpha[Math.floor(Math.random() * alpha.length)];
    var b = alpha[Math.floor(Math.random() * alpha.length)];
    var c = alpha[Math.floor(Math.random() * alpha.length)];
    var d = alpha[Math.floor(Math.random() * alpha.length)];
    var e = alpha[Math.floor(Math.random() * alpha.length)];
    var f = alpha[Math.floor(Math.random() * alpha.length)];
    var g = alpha[Math.floor(Math.random() * alpha.length)];
  }
  var code = a + " " + b + " " + c + " " + d + " " + e + " " + f;
  return code;
}

export function ValidCaptcha(mainCaptcha, txtInput) {
  var string1 = mainCaptcha;
  var string2 = txtInput;
  if (string1 == string2) {
    return true;
  } else {
    return false;
  }
}

export function removeSpaces(string) {
  return string.split(" ").join("");
}

export function validateEmail(email) {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return re.test(email);
}

export function phonenumberValidation(inputtxt) {
  var mob = /^[1-9]{1}[0-9]{9}$/;
  if (mob.test(inputtxt) == false) {
    return false;
  }
  return true;
}

export function signupValidation(
  firstName, emailId, mobileNo, password, cpassword, textCaptcha, hiddenCaptcha
) {
  var message = "";
  var field = "xxx";
  let checkCaptch = ValidCaptcha(textCaptcha, hiddenCaptcha);
  if (!firstName) {
    message = "Please Enter First Name Properly";
    field = "firstName";
  } else if (!emailId) {
    message = "Please Enter Your Email Id ";
    field = "emailId";
  }  else if (!validateEmail(emailId)) {
    message = "Please Enter Valid Email Id ";
    field = "emailId";
  } 
  else if (!mobileNo) {
    message = "Please Enter your mobile no";
    field = "mobileNo";
  }else if(!phonenumberValidation(mobileNo))
  { message = "Please Enter valid mobile no";
    field = "mobileNo";}
   else if (!password) {
    message = "Enter your password properly";
    field = "password";
  } else if (!cpassword) {
    message = "Enter confirm password properly";
    field = "cpassword";
  } else if (password != cpassword) {
    message = "Your Passwords are not matched please check properly";
  } else if (!checkCaptch) {
    message = "Captcha validation failed , please try again";
  } else {
    message = "";
  }

  return [message, field];
}

export function changeDateFormat(appDate) {
  let newAppDate = "";
  if (appDate) {
    const a = appDate.split("-");
    newAppDate = a[2] + "/" + a[1] + "/" + a[0];
  }
  return newAppDate;
}

export function apiCallingWithoutToken(requestOptions) {
  var parameters = JSON.parse(requestOptions.body);

  var ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(JSON.stringify(parameters)),
    ENC_KEY
  ).toString();

  let tokenData = {
    method: "POST",
    body: JSON.stringify({ token: ciphertext }),
  };

  return fetch(apiUrl, requestOptions)
    .then((data) => {
      if (!data.ok) {
       console.error(`HTTP error! Status: ${data.status}`);
      }
      return data.json();
    })
    .then((res) => {
      var bytes = CryptoJS.AES.decrypt(res.token, ENC_KEY);
      var decryptedData = JSON.parse(
        JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
      );
      return decryptedData;
    })
    .catch((error) => {
      console.error("apiCallingWithoutToken failed:", error);
      return false;
    });
}

export function prependZero(v) {
  if (v < 9) return "0" + v;
  else return v;
}

var currentHours = 0;
var currentMinutes = 0;
var currentSeconds = 0;
currentMinutes = (currentMinutes < 10 ? "0" : "") + currentMinutes;
currentHours = (currentHours < 10 ? "0" : "") + currentHours;

export function updateClock() {
  currentSeconds++;
  var currentTimeString = "00:00:00";
  if (currentSeconds > 59) {
    currentMinutes++;
    currentSeconds = 0;
    currentMinutes = (currentMinutes < 10 ? "0" : "") + currentMinutes;
  }
  if (currentMinutes > 59) {
    currentHours++;
    currentMinutes = 0;
  }
  currentSeconds = (currentSeconds < 10 ? "0" : "") + currentSeconds;

  currentTimeString = currentHours + ":" + currentMinutes + ":" + currentSeconds;
  return currentTimeString;
}

export function formatDatePickerToddMMyyyy(date) {
  if (date == null) {
    return "";
  } else {
    let dd = date.getDate();
    let mm = date.getMonth() + 1;
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let month = mm < 10 ? "0" + mm : mm;
    return day + "/" + month + "/" + date.getFullYear();
  }
}

export const setAuthTokens = (token, refresh) => {
  authToken = token;
  refreshToken = refresh;
  secureStorage.setItem('authToken', token);
  secureStorage.setItem('refreshToken', refresh);
};

export const getAuthToken = () => authToken;

export const forceLogout = () => {
  clearAuthTokens();
  clearAuthData();
};

const refreshAuthToken = async () => {
  try {
    if (isRefreshing) return false;
    isRefreshing = true;

    if (!refreshToken) {
      console.error("No refresh token available");
      isRefreshing = false;
      return false;
    }

    // If refresh is already in progress, return the existing promise
    if (refreshPromise) {
      return refreshPromise;
    }

    refreshPromise = (async () => {
      try {
        const refreshData = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            functionName: "refreshToken",
            refreshToken: refreshToken
          }),
        };

        const response = await fetch(apiUrl, refreshData);

        if (!response.ok) {
          console.error("Refresh token request failed");
          return false;
        }

        const data = await response.json();
        const bytes = CryptoJS.AES.decrypt(data.token, ENC_KEY);
        const decryptedData = JSON.parse(
          JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        );

        if (decryptedData.success === "1") {
          setAuthTokens(decryptedData.token, decryptedData.refreshToken);
          return true;
        }

        return false;
      } finally {
        isRefreshing = false;
        refreshPromise = null;
      }
    })();

    return refreshPromise;
  } catch (error) {
    console.error("Token refresh failed:", error);
    isRefreshing = false;
    refreshPromise = null;
    return false;
  }
};

export const clearAuthTokens = () => {
  authToken = '';
  refreshToken = '';
  secureStorage.removeItem('authToken');
  secureStorage.removeItem('refreshToken');
  authHelper.logout();
};

// 1. Basic authentication validation
export const validateAuthentication = () => {
  const hasAuthToken = secureStorage.getItem("authToken");
  const hasUserId = authHelper.getUserId();
  
  if (!hasAuthToken || !hasUserId) {
    forceLogout();
    return false;
  }
  return true;
};

// 2. Role checking function with token refresh integration
export const checkUserRoleFunction = async (retry = true) => {
  if (!validateAuthentication()) {
    return false;
  }

  try {
    let postData = {
      functionName: "checkUserRole",
      userId: authHelper.getUserId(),
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    };

    const tokenData = {
      method: "POST",
      headers,
      body: JSON.stringify(postData),
    };

    const response = await fetch(apiUrl, tokenData);
    
    if (!response.ok) {
    console.error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const bytes = CryptoJS.AES.decrypt(data.token, ENC_KEY);
    const decryptedData = JSON.parse(
      JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    );

    // Handle authentication failures with token refresh logic
    if (decryptedData.success === "0") {
      const authErrorKeywords = ['token', 'auth', 'unauthorized', 'expired', 'invalid', 'session'];
      const hasAuthError = authErrorKeywords.some(keyword =>
        decryptedData.errorMessage?.toLowerCase().includes(keyword)
      );

      if (hasAuthError && retry) {
        const refreshed = await refreshAuthToken();
        if (refreshed) {
          return checkUserRoleFunction(false);
        } else {
          forceLogout();
          return false;
        }
      }
      
      forceLogout();
      return false;
    }

    return decryptedData;

  } catch (error) {
    console.error("Role check failed:", error);
    
    if (error.message.includes("Authentication") || 
        error.message.includes("network") || 
        error.message.includes("token")) {
      forceLogout();
    }
    
    return false;
  }
};

export const apiCalling = async (requestOptions, retry = true) => {
  try {
    // First validate basic authentication
    if (!validateAuthentication()) {
      return { success: "0", errorMessage: "Authentication required" };
    }

    // Check user role for every API call with proper await
    const roleCheck = await checkUserRoleFunction();
    if (!roleCheck) {
      return { 
        success: "0", 
        errorMessage: "Role validation failed. Please login again." 
      };
    }

    let parameters = JSON.parse(requestOptions.body);
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    };

    const tokenData = {
      method: "POST",
      headers,
      body: JSON.stringify(parameters),
    };

    const response = await fetch(apiUrl, tokenData);
    
    if (!response.ok) {
     console.error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const bytes = CryptoJS.AES.decrypt(data.token, ENC_KEY);
    const decryptedData = JSON.parse(
      JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    );

    // Handle authentication failures
    if (decryptedData.success === "0") {
      const authErrorKeywords = ['token', 'auth', 'unauthorized', 'expired', 'invalid', 'session'];
      const hasAuthError = authErrorKeywords.some(keyword =>
        decryptedData.errorMessage?.toLowerCase().includes(keyword)
      );

      if (hasAuthError && retry) {
        const refreshed = await refreshAuthToken();
        if (refreshed) {
          return apiCalling(requestOptions, false);
        } else {
          forceLogout();
          return decryptedData;
        }
      }

      return decryptedData;
    }

    return decryptedData;
  } catch (error) {
    console.error("API call failed:", error);
    
    if (error.message.includes("Authentication") || error.message.includes("network")) {
      forceLogout();
    }
    
    return { 
      success: "0", 
      errorMessage: error.message || "API call failed",
      error: true 
    };
  }
};

const AES = {
  utils: {
    convertUtf8ToArrayBuffer: (str) => {
      try {
        const utf8 = unescape(encodeURIComponent(str));
        const bytes = new Uint8Array(utf8.length);
        for (let i = 0; i < utf8.length; i++) {
          bytes[i] = utf8.charCodeAt(i);
        }
        return bytes;
      } catch (error) {
        console.error(`String conversion failed: ${error.message}`);
      }
    },
    convertArrayBufferToUtf8: (buffer) => {
      try {
        const bytes = new Uint8Array(buffer);
        let str = '';
        for (let i = 0; i < bytes.length; i++) {
          str += String.fromCharCode(bytes[i]);
        }
        return decodeURIComponent(escape(str));
      } catch (error) {
        console.error(`Buffer conversion failed: ${error.message}`);
      }
    },
    randomBytes: (length) => {
      try {
        const bytes = new Uint8Array(length);
        crypto.getRandomValues(bytes);
        return bytes;
      } catch (error) {
        console.error(`Random bytes generation failed: ${error.message}`);
      }
    }
  },
  SHA: {
    sha256: async (buffer) => {
      try {
        return await crypto.subtle.digest('SHA-256', buffer);
      } catch (error) {
        console.error(`SHA-256 hashing failed: ${error.message}`);
      }
    }
  },
  AES: {
    encrypt: async (plaintext, key, iv) => {
      try {
        const cryptoKey = await crypto.subtle.importKey(
          'raw',
          key,
          { name: 'AES-CBC' },
          false,
          ['encrypt']
        );
        return await crypto.subtle.encrypt(
          { name: 'AES-CBC', iv },
          cryptoKey,
          plaintext
        );
      } catch (error) {
        console.error(`Encryption failed: ${error.message}`);
      }
    },
    decrypt: async (ciphertext, key, iv) => {
      try {
        const cryptoKey = await crypto.subtle.importKey(
          'raw',
          key,
          { name: 'AES-CBC' },
          false,
          ['decrypt']
        );
        return await crypto.subtle.decrypt(
          { name: 'AES-CBC', iv },
          cryptoKey,
          ciphertext
        );
      } catch (error) {
        console.error(`Decryption failed: ${error.message}`);
      }
    }
  }
};

const toBase64 = (buffer) => {
  try {
    const binary = Array.from(new Uint8Array(buffer))
      .map(b => String.fromCharCode(b))
      .join('');
    return btoa(binary);
  } catch (error) {
    console.error(`Base64 encoding failed: ${error.message}`);
  }
};

export const encryptDataNewMethode = async (data, password = ENC_KEY) => {
  try {
    const key = await deriveNodeKey(password);
    const iv = await AES.utils.randomBytes(16);
    const plaintext = AES.utils.convertUtf8ToArrayBuffer(JSON.stringify(data));
    const encryptedBytes = await AES.AES.encrypt(plaintext, key, iv);
    return `${toBase64(iv)}:${toBase64(encryptedBytes)}`;
  } catch (error) {
    console.error('Encryption error:', error);
  }
};

export const decryptData = async (payload, password = ENC_KEY) => {
  try {
    const [ivBase64, cipherBase64] = payload.split(':');
    if (!ivBase64 || !cipherBase64) {
      console.error('Invalid payload format: expected iv:cipherText');
    }
    const key = await deriveNodeKey(password);
    const iv = fromBase64(ivBase64);
    const cipher = fromBase64(cipherBase64);
    const decryptedBytes = await AES.AES.decrypt(cipher, key, iv);
    const decryptedText = AES.utils.convertArrayBufferToUtf8(decryptedBytes);
    return JSON.parse(decryptedText);
  } catch (error) {
    console.error('Decryption error:', error);
  }
};

const fromBase64 = (base64) => {
  try {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  } catch (error) {
    console.error(`Base64 decoding failed: ${error.message}`);
  }
};

const deriveNodeKey = async (password) => {
  try {
    const passwordBytes = AES.utils.convertUtf8ToArrayBuffer(password);
    const hash = await AES.SHA.sha256(passwordBytes);
    return new Uint8Array(hash);
  } catch (error) {
    console.error(`Key derivation failed: ${error.message}`);
  }
};

const createApiHandler = (baseUrl) => async (requestOptions) => {
  try {
    if (!requestOptions || !requestOptions.body) {
      console.error('Invalid request options: body is required');
    }

    let parsedBody;
    try {
      parsedBody = JSON.parse(requestOptions.body);
    } catch (error) {
      console.error('Invalid JSON in request body');
    }

    const encryptedPayload = await encryptDataNewMethode(parsedBody);

    const response = await fetch(baseUrl, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        ...(requestOptions.headers || {})
      },
      body: JSON.stringify({ token: encryptedPayload }),
    });

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch {
        errorData = { message: `Request failed with status ${response.status}` };
      }
      console.error(errorData.message || 'API request failed');
    }

    const res = await response.json();
    if (!res.token) {
      console.error('Invalid response format: token missing');
    }

    return await decryptData(res.token);
  } catch (error) {
    console.error(`API call to ${baseUrl} failed:`, error);
    return {
      success: false,
      error: true,
      errorMessage: error.message || 'API request failed',
      status: error.status || 500,
      originalError: error
    };
  }
};

export function awsAPIUrlcommonWithoutToken(req) {
  var parameters = JSON.parse(req.body);
  return fetch(apiUrlcommon, req)
    .then((data) => data.json())
    .then((res) => {
      var bytes = CryptoJS.AES.decrypt(res.token, ENC_KEY);
      var decryptedData = JSON.parse(
        JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
      );
      return decryptedData;
    });
}

export const awsAPIUrlcommon = async (requestOptions, retry = true) => {
  try {
    // First validate basic authentication
    if (!validateAuthentication()) {
      return { success: "0", errorMessage: "Authentication required" };
    }

    // Check user role for every API call with proper await
    const roleCheck = await checkUserRoleFunction();
    if (!roleCheck) {
      return { 
        success: "0", 
        errorMessage: "Role validation failed. Please login again." 
      };
    }

    let parameters = JSON.parse(requestOptions.body);
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    };

    const tokenData = {
      method: "POST",
      headers,
      body: JSON.stringify(parameters),
    };

    const response = await fetch(apiUrlcommon, tokenData);
    const data = await response.json();

    const bytes = CryptoJS.AES.decrypt(data.token, ENC_KEY);
    const decryptedData = JSON.parse(
      JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    );

    // Handle authentication failures
    if (decryptedData.success === "0") {
      const authErrorKeywords = ['token', 'auth', 'unauthorized', 'expired', 'invalid', 'session'];
      const hasAuthError = authErrorKeywords.some(keyword =>
        decryptedData.errorMessage?.toLowerCase().includes(keyword)
      );

      if (hasAuthError && retry) {
        const refreshed = await refreshAuthToken();
        if (refreshed) {
          return awsAPIUrlcommon(requestOptions, false);
        } else {
          forceLogout();
          return decryptedData;
        }
      }

      return decryptedData;
    }

    return decryptedData;
  } catch (error) {
    console.error("API call failed:", error);
    if (error.message.includes("Authentication") || error.message.includes("network")) {
      forceLogout();
    }
    return { 
      success: "0", 
      errorMessage: error.message || "API call failed",
      error: true 
    };
  }
};

const createApiHandlerawsAPIUrlcommon = (baseUrl) => async (requestOptions) => {
  try {
    if (!requestOptions || !requestOptions.body) {
      console.error('Invalid request options: body is required');
    }

    let parsedBody;
    try {
      parsedBody = JSON.parse(requestOptions.body);
    } catch (error) {
      console.error('Invalid JSON in request body');
    }

    const encryptedPayload = await encryptDataNewMethode(parsedBody);

    const response = await fetch(baseUrl, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        ...(requestOptions.headers || {})
      },
      body: JSON.stringify({ token: encryptedPayload }),
    });

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch {
        errorData = { message: `Request failed with status ${response.status}` };
      }
      console.error(errorData.message || 'API request failed');
    }

    const res = await response.json();
    if (!res.token) {
      console.error('Invalid response format: token missing');
    }

    return await decryptData(res.token);
  } catch (error) {
        console.error(`API call to ${baseUrl} failed:`, error);
    return {
      success: false,
      error: true,
      errorMessage: error.message || 'API request failed',
      status: error.status || 500,
      originalError: error
    };
  }
};

export const apiUrlRelianceFunction = createApiHandler(apiUrlRelianceConst);

export function encryptData(reqBody) {
  // SHA-256 hash of key to make it 256-bit
  const hashedKey = CryptoJS.SHA256(ENC_KEY);

  // Generate 16 bytes random IV
  const iv = CryptoJS.lib.WordArray.random(16);

  const message = JSON.stringify(reqBody);

  const encrypted = CryptoJS.AES.encrypt(message, hashedKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const encryptedBase64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  const ivBase64 = CryptoJS.enc.Base64.stringify(iv);

  return `${ivBase64}:${encryptedBase64}`;
}

const imageUploadURL = "https://75vfqs60v3.execute-api.ap-south-1.amazonaws.com/";
export function UploadImage(image, path, bucket) {
  const url = `${imageUploadURL}newUpload?bucket=${bucket}&bucketPath=${path}`;
  return axios
    .post(url, image)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error uploading image:", err);
      throw err;
    });
}

const elasticSearchApiCall = "https://0nfy1ql618.execute-api.ap-south-1.amazonaws.com/test/elasticsearch";
export function elasticSearchApicall(data) {
  return axios
    .post(elasticSearchApiCall, data)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in elastic search API call:", err);
      throw err;
    });
}

export async function asyncApiUrlRelianceElasticSearch(req) {
  return await fetch(apiUrlRelianceElasticSearchConst, req)
    .then((data) => data.json())
    .then((res) => res);
}

export async function asyncAwsAPIUrlcommon(req) {
  var parameters = JSON.parse(req.body);
  var cipher = CryptoJS.AES.encrypt(
    JSON.stringify(JSON.stringify(parameters)),
    ENC_KEY
  ).toString();

  let requestParameter = {
    method: "POST",
    body: JSON.stringify({ token: cipher }),
  };

  return await fetch(apiUrlcommon, requestParameter)
    .then((data) => {
      return data.json();
    })
    .then((res) => {
      var bytes = CryptoJS.AES.decrypt(res.token, ENC_KEY);
      var decryptedData = JSON.parse(
        JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
      );
      return decryptedData;
    })
    .catch((err) => {
      return { success: 0, errorMessage: "Something went wrong." };
    });
}

export function changeDateFormat2(appDate) {
  let newAppDate = "";
  if (appDate) {
    const a = appDate.split("/");
    newAppDate = a[2] + "-" + a[1] + "-" + a[0];
  }
  return newAppDate;
}

export function sendMailOrder(postData) {
  return axios.post(
    "https://2yhrka7axi.execute-api.us-west-2.amazonaws.com/prod/contactus",
    postData
  );
}

// Add console protection in production
if (isProduction) {
  const originalConsole = { ...console };
  
  Object.keys(console).forEach(method => {
    if (typeof console[method] === 'function' && method !== 'error' && method !== 'warn') {
      console[method] = () => {};
    }
  });
  
  // Protect localStorage from being overwritten
  Object.defineProperty(window, 'localStorage', {
    value: localStorage,
    writable: false,
    configurable: false
  });
  
  // Prevent right-click and F12 in production
  document.addEventListener('contextmenu', (e) => e.preventDefault());
  document.addEventListener('keydown', (e) => {
    if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
      e.preventDefault();
    }
  });
}